<template>
  <div>
    <button
      ref="dropdownEl"
      class="btn btn-icon btn-ghost btn-sm"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <Icon icon="material-symbols:more-vert" />
    </button>
    <ul class="dropdown-menu">
      <li v-if="editable">
        <button class="btn btn-ghost btn-sm dropdown-item" type="button" @click="$emit('edit')">
          {{ translate('Edit') }}
        </button>
      </li>
      <li v-if="!!userStore.hasPermission('login-policy:write') && !editable">
        <button
          class="btn btn-ghost btn-sm dropdown-item"
          type="button"
          @click="$emit('editAsNew')"
        >
          {{ translate('Edit as new version') }}
        </button>
      </li>
      <li v-if="editable">
        <button class="btn btn-ghost btn-sm dropdown-item" type="button" @click="$emit('delete')">
          {{ translate('Delete') }}...
        </button>
      </li>
      <li>
        <button class="btn btn-ghost btn-sm dropdown-item" type="button" @click="$emit('view')">
          {{ translate('View') }}
        </button>
      </li>
      <template v-if="!!userStore.hasPermission('login-policy:write')">
        <li v-if="loginPolicy.active">
          <button
            class="btn btn-ghost btn-sm dropdown-item"
            type="button"
            @click="$emit('deactivate')"
          >
            {{ translate('Deactivate') }}...
          </button>
        </li>
        <li v-else>
          <button
            class="btn btn-ghost btn-sm dropdown-item"
            type="button"
            :disabled="loginPolicyStore.domains.length === 0"
            @click="$emit('activate')"
          >
            {{ translate('Activate') }}...
          </button>
        </li>
      </template>
    </ul>
  </div>
</template>
<script setup lang="ts">
import {LoginPolicy} from '@/api/apolloPlatform/loginPolicy';
import Dropdown from 'bootstrap/js/dist/dropdown';

defineEmits<{
  edit: [];
  editAsNew: [];
  delete: [];
  view: [];
  deactivate: [];
  activate: [];
}>();
const props = defineProps<{loginPolicy: LoginPolicy}>();
const userStore = useUserStore();
const {translate} = useLocalisation();
const loginPolicyStore = useLoginPolicyStore();

const editable = computed(
  () => userStore.hasPermission('login-policy:write') && !props.loginPolicy.frozen,
);

const dropdownEl = ref<Element>();
const dropdown = ref();

const observer = ref<IntersectionObserver>();

onMounted(() => {
  if (dropdownEl.value) {
    dropdown.value = new Dropdown(dropdownEl.value, {
      popperConfig(defaultBsPopperConfig) {
        return {...defaultBsPopperConfig, strategy: 'fixed'};
      },
    });

    // Close the dropdown if the icon goes off screen. Without this, the dropdown
    // can float outside of the settings dialog window.
    observer.value = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          dropdown.value.hide();
        }
      },
      {
        root: document.getElementById('dialog-settings'),
        threshold: 0.4,
      },
    );
    observer.value.observe(dropdownEl.value);
  }
});

onUnmounted(() => {
  observer.value?.disconnect();
  dropdown.value?.dispose();
});
</script>
